import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '@rci/self-serve-fido/shared/authentication/authentication.service';
import { AccountDetailService } from '@rci/self-serve-fido/state/account/account-detail.service';
import { ApiEndpointConfigService } from '@rci/self-serve-shared';
import { RogersBankAuthRequest, RogersBankAuthResponse } from '@rogers/self-serve-rogers-bank';
import { combineLatest } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RogersBankService {
  private readonly accountDetailsService = inject(AccountDetailService);
  private readonly apiEndpointConfig = inject(ApiEndpointConfigService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly http = inject(HttpClient);

  authenticateUser$(authRequest: RogersBankAuthRequest) {
    const headers = this.authenticationService.getDomainServiceHeaders(authRequest.language);
    const baseUrl = this.apiEndpointConfig.msapiBaseUrl;
    if (authRequest.accountAlias && authRequest.contactIdAlias) {
      const { accountAlias, contactIdAlias } = authRequest;
      const url = `${baseUrl}ssc/promotions/v3/customer/accounts/${accountAlias}/contacts/${contactIdAlias}/rogers-bank/redirect-url?bannerType=${authRequest.bannerType}&productCode=${authRequest.productCode}`;
      return this.http.get<RogersBankAuthResponse>(url, { headers });
    }
    if (authRequest.ecId) {
      return combineLatest([
        this.accountDetailsService.fetchAccountsDetails$(),
        this.accountDetailsService.getSelectedAccountDetail$(),
      ]).pipe(
        take(1),
        switchMap(([_, { alias, accountTypeNumber }]) => {
          const { ecId, agentId, channel, domain, state } = authRequest;
          const url = `${baseUrl}ssc/accounts/v2/tokens/accountlist/rogers-bank?account=${alias}&ecid=${ecId}&accounttypenumber=${accountTypeNumber}&agent=${agentId}&channel=${channel}&dest=rogers-bank&state=${state}&domain=${domain}`;
          return this.http.get<RogersBankAuthResponse>(url, { headers });
        }),
      );
    }
    const { domain, channel, state, offerCode } = authRequest;
    const url = `${baseUrl}ssc/accounts/v2/tokens/accountlist/rogers-bank-blank?channel=${channel}&state=${state}&domain=${domain}&offerCode=${offerCode}`;
    return this.http.get<RogersBankAuthResponse>(url, { headers });
  }
}
